export const CHANGE_TAB = 'app/OfficesPage/CHANGE_TAB';
